interface Props {
    label: string
    name: string
    value: string | number | boolean
    onChange: (data: HTMLInputElement) => void
    disabled: boolean
    required: boolean
    hide?: boolean
}

const FormTextArea = (props: Props) => {

    const {label, name, value, onChange, disabled, required, hide} = props

    if (hide) {
        return null
    }

    return (
        <div className={'c-form-input-group'}>
            <label htmlFor={name}>{label}{required && <>*</>}</label>
            <textarea id={name} name={name}
                      value={value}
                      onChange={(event: any) => {
                          onChange(event.target)
                      }}
                      disabled={disabled}
                      required={required}/>
        </div>
    )
}

export default FormTextArea;